import {
    gsap,
} from 'gsap';
import {
    ScrollTrigger,
} from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
    // Select the sections and header
    const lhssSections = document.querySelectorAll('.locked-horizontal-scroll-section');
    const header = document.querySelector('header.main-header');

    // Variable to store the header height
    let headerHeight = header ? header.offsetHeight : 0;

    // Function to update headerHeight when resizing
    function updateHeaderHeight() {
        headerHeight = header ? header.offsetHeight : 0;

        // Optionally, you could apply this height to your sections here:
        lhssSections.forEach(section => {
            section.style.setProperty('--header-height', `${headerHeight}px`);
        });
    }

    // Initial update on page load
    updateHeaderHeight();

    // Add event listener to handle resize
    window.addEventListener('resize', updateHeaderHeight);
    lhssSections.forEach(section => {
        const slider = section.querySelector('.lhss-wrap');
        const wrapper = slider.querySelector('.lhss-list');
        const item = wrapper.querySelectorAll('.lhss-item');
        const images = slider.querySelectorAll('.lhss-bg-img');

        if (item.length > 1) {
            // Dynamically calculate the total scroll width by adjusting for all images and content
            const totalContentWidth = wrapper.scrollWidth;
            const sliderWidth = slider.offsetWidth;
            const totalScroll = totalContentWidth - sliderWidth;

            const headerHeight = header ? header.offsetHeight + 10 : 0;

            // Horizontal scroll animation (for the wrapper)
            gsap.to(wrapper, {
                x: -totalScroll,
                ease: 'none',
                scrollTrigger: {
                    trigger: slider,
                    start: `top ${headerHeight}`,
                    end: `+=${totalScroll}`,
                    scrub: 1,
                    pin: true,
                    anticipatePin: 1,
                },
            });

            // Parallax effect for each background image
            images.forEach((imgEle, index) => {
                // Adjust for the first image to move 5% and others to move -10%
                const xValue = index === 0 ? '10%' : '-10%'; // 5% for the first image, -10% for the rest
                const delay = index * 0.1; // Stagger delay for each image (optional)

                gsap.to(imgEle, {
                    x: xValue,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: slider,
                        start: `top ${headerHeight}`,
                        end: `+=${totalScroll}`,
                        scrub: 1,
                        delay: delay, // Staggered delay for each image
                    },
                });
            });

        }
    });
});
